import React from "react";

const clientLogos = [
  "/assets/imgs/brand/c1.webp",
  "/assets/imgs/brand/c2.webp",
  "/assets/imgs/brand/c3.webp",
  "/assets/imgs/brand/c4.webp",
  "/assets/imgs/brand/cl1.jpg",
  "/assets/imgs/brand/cl2.jpg",
  "/assets/imgs/brand/cl3.jpg",
  "/assets/imgs/brand/cl4.webp",
  "/assets/imgs/brand/cl5.webp",
  "/assets/imgs/brand/cl6.jpg"
];

const ClientBrandsSection: React.FC = () => {
  return (
    <div className="client-area has_fade_anim">
      <div className="container">
        <div className="client-area-inner section-spacing">
          <div className="client-area-text">
            <h2 className="text has_fade_anim">
              We worked with largest global brands
            </h2>
          </div>
          <div className="clients-wrapper-box has_fade_anim">
            <div className="clients-wrapper">
              {clientLogos.map((logo, index) => (
                <div className="client-box" key={index}>
                  <img
                    src={logo}
                    alt="client image" loading="lazy" decoding="async" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientBrandsSection;
